var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "-3 -4 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.333,
    height: 13.333,
    x: 2.133,
    y: 1.333,
    fill: "#00BB8E",
    rx: 6.667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00BB8E",
    fillRule: "evenodd",
    d: "M12.088 5.766a.575.575 0 0 1-.016.813L8.086 10.41 5.528 7.951a.575.575 0 0 1 .797-.828l1.761 1.693 3.19-3.066a.575.575 0 0 1 .812.016",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.846 5.94a.53.53 0 0 1-.015.75l-3.692 3.532-2.37-2.267a.53.53 0 0 1-.015-.75.534.534 0 0 1 .753-.014l1.632 1.561 2.954-2.826a.534.534 0 0 1 .753.014",
    clipRule: "evenodd"
  })));
};
export default SvgSuccessIcon;